import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Clock, Phone, Calendar, CheckCircle2 } from 'lucide-react';

const Location = () => {
  return (
    <section className="section bg-gradient-to-br from-white to-gray-100">
      <div className="container mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.5 }}
          className="text-center mb-12"
        >
          <h2 className="section-title text-gray-900">Notre Zone d'Intervention</h2>
          <p className="text-lg max-w-3xl mx-auto text-gray-600">
            Basés à Camaret-sur-Aigues, nous intervenons dans toute la région pour vos diagnostics immobiliers.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-start">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.5 }}
            className="bg-white rounded-lg shadow-lg p-8 hover:shadow-xl transition-all duration-300"
          >
            <div className="flex items-start space-x-4 mb-8">
              <MapPin className="h-8 w-8 text-dk-blue flex-shrink-0 mt-1" />
              <div>
                <h3 className="text-xl font-semibold mb-3 text-gray-900">Zone d'intervention</h3>
                <p className="mb-4 text-gray-600 leading-relaxed">
                  Nous intervenons à Orange (84100) et dans un rayon de 60 km autour.
                  Notre équipe se déplace rapidement pour répondre à vos besoins, que vous soyez un particulier ou un professionnel.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4 mb-8">
              <Clock className="h-8 w-8 text-dk-blue flex-shrink-0 mt-1" />
              <div className="w-full">
                <h3 className="text-xl font-semibold mb-4 text-gray-900">Horaires d'intervention</h3>
                <div className="space-y-4">
                  <div className="bg-gradient-to-r from-dk-blue to-dk-light-blue rounded-lg p-4 text-white">
                    <div className="flex items-center justify-between mb-2">
                      <div className="flex items-center">
                        <Calendar className="h-5 w-5 mr-2" />
                        <span className="font-medium">Lundi - Vendredi</span>
                      </div>
                      <div className="flex items-center">
                        <CheckCircle2 className="h-5 w-5 mr-2" />
                        <span className="font-medium">8h00 - 19h00</span>
                      </div>
                    </div>
                    <p className="text-sm text-white/80">Interventions sur rendez-vous</p>
                  </div>

                  <div className="bg-gradient-to-r from-gray-100 to-gray-200 rounded-lg p-4">
                    <div className="flex items-center justify-between mb-2">
                      <div className="flex items-center">
                        <Calendar className="h-5 w-5 mr-2 text-dk-blue" />
                        <span className="font-medium text-gray-800">Samedi</span>
                      </div>
                      <div className="flex items-center">
                        <CheckCircle2 className="h-5 w-5 mr-2 text-dk-blue" />
                        <span className="font-medium text-gray-800">Sur rendez-vous</span>
                      </div>
                    </div>
                    <p className="text-sm text-gray-600">Disponible selon planning</p>
                  </div>

                  <div className="bg-gray-100 rounded-lg p-4">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center">
                        <Calendar className="h-5 w-5 mr-2 text-gray-500" />
                        <span className="font-medium text-gray-500">Dimanche</span>
                      </div>
                      <span className="text-gray-500 font-medium">Fermé</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-8">
              <a 
                href="tel:0789307500"
                className="btn-primary w-full flex items-center justify-center text-lg group hover:bg-dk-blue/90 transition-all duration-300"
              >
                <Phone className="h-5 w-5 mr-2 group-hover:animate-pulse" />
                Contactez-nous
              </a>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="h-[600px] rounded-lg overflow-hidden shadow-lg"
          >
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d45744.320811354974!2d4.778380591723633!3d44.13850999999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12b57d27e1052b23%3A0x408ab2ae4c1f000!2s84100%20Orange!5e0!3m2!1sfr!2sfr!4v1711462552614!5m2!1sfr!2sfr"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="rounded-lg"
            ></iframe>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Location;